export const BagOpenIcon = (props: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3.68897 10.5262C3.34199 9.25395 4.29975 8 5.6185 8H19.3815C20.7002 8 21.658 9.25396 21.311 10.5262L19.4019 17.5262C19.1646 18.3964 18.3743 19 17.4724 19H12.5H7.52759C6.62569 19 5.83537 18.3964 5.59806 17.5262L3.68897 10.5262Z" fill="white" stroke="white" strokeWidth="1.5"/>
    <path d="M9 10V6C9 4.89543 9.89543 4 11 4H14C15.1046 4 16 4.89543 16 6V10" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);
